import { checkEnvironment } from '@saviynt/common';

const getAccountDetailsApiUrl = (accountKey) => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/accounts/${accountKey}`;
};

export default getAccountDetailsApiUrl;
